/**
 * setStoredKey - Saves a key to storage for a specified duration
 * @param {String} key - The unique key to be stored
 * @param {Number} duration - The number of milliseconds until this key expires, or 0 to save to sessionStorage
 * @returns {Boolean} - Whether or not the key was saved successfully
 */
export const setStoredKey = (key, duration = 0) => {
    try {
        if (!duration)
            window.sessionStorage.setItem(key, 'true');
        else {
            const expires = Date.now() + parseInt(`${duration}`, 10);
            window.localStorage.setItem(key, `${expires}`);
        }
        return true;
    }
    catch (e) {
        if (typeof window !== 'undefined')
            console.warn(`Could not write to storage: ${e}.`);
    }
    return false;
};
/**
 * useStoredKey - Returns true if a key is currently saved to storage
 * @param {String} key - The unique key that was stored
 * @returns {Boolean} - Whether or not the key is currently saved in storage
 */
export const useStoredKey = (key) => {
    try {
        if (window.sessionStorage.getItem(key))
            return true;
        const expires = window.localStorage.getItem(key) || 0;
        const expired = Date.now() > parseInt(`${expires}`, 10);
        if (expired)
            window.localStorage.removeItem(key);
        return !expired;
    }
    catch (e) {
        if (typeof window !== 'undefined')
            console.warn(`Could not read from storage: ${e}.`);
    }
    return false;
};
//# sourceMappingURL=useStoredKey.js.map